var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_697_5793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5259 8.51927C31.3449 7.83849 30.9884 7.21716 30.4919 6.71748C29.9954 6.21779 29.3764 5.85727 28.6968 5.67199C26.1949 4.99927 16.1949 4.99927 16.1949 4.99927C16.1949 4.99927 6.19495 4.99927 3.69313 5.67199C3.01352 5.85727 2.39449 6.21779 1.898 6.71748C1.4015 7.21716 1.04495 7.83849 0.864037 8.51927C0.194946 11.032 0.194946 16.272 0.194946 16.272C0.194946 16.272 0.194946 21.512 0.864037 24.0247C1.04495 24.7055 1.4015 25.3268 1.898 25.8265C2.39449 26.3262 3.01352 26.6867 3.69313 26.872C6.19495 27.5447 16.1949 27.5447 16.1949 27.5447C16.1949 27.5447 26.1949 27.5447 28.6968 26.872C29.3764 26.6867 29.9954 26.3262 30.4919 25.8265C30.9884 25.3268 31.3449 24.7055 31.5259 24.0247C32.195 21.512 32.1949 16.272 32.1949 16.272C32.1949 16.272 32.195 11.032 31.5259 8.51927Z",
    fill: "#565556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9222 21.0303V11.5139L21.2859 16.2721L12.9222 21.0303Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_697_5793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.163208 0.271973)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/YoutubeIcon.05a005c57af7a59ad1fc1c528f9ecce9.svg";
export { ForwardRef as ReactComponent };